'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.stringable = stringable;

function stringable(thing) {
    return thing !== null && typeof thing !== 'undefined' && typeof (thing.toString === 'function');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/reactable/lib/reactable/lib/stringable.js
// module id = 496
// module chunks = 0